// FAQ copy for GEO (generative engine optimisation) — factual, quotable answers.

export const homeFaqs = [
  {
    q: 'What is a Print MIS?',
    a: 'A Print MIS (Management Information System) is the software backbone of a printing company. It handles estimating, quoting, order processing, production planning and scheduling, stock control, job costing, despatch and invoicing in one system — replacing spreadsheets and disconnected tools so you can see the true cost and status of every job in real time.',
  },
  {
    q: 'What makes Imprint different from other Print MIS providers?',
    a: 'Imprint is a privately owned UK company that has been trading since 1979, owns all of its own code, and is dedicated solely to MIS for the print and packaging industry. We are technically led — everyone you deal with has worked in print or IT, we employ no outside salespeople, and the same people stay with you from the first meeting through to go-live and beyond.',
  },
  {
    q: 'Which print sectors does Imprint MIS cover?',
    a: 'We build dedicated systems — not adapted one-size-fits-all software — for commercial and litho printing, cartons and packaging, security printing, direct mail and mailing houses, books and magazines, labels, wide format, and print management companies.',
  },
  {
    q: 'What systems does Imprint MIS integrate with?',
    a: 'Imprint MIS has 24+ pre-built integrations: accounting with Sage, Xero and QuickBooks; JDF/CIP4 workflow with Heidelberg, Kodak, Agfa and MBO; real-time machine data from Heidelberg, HP, Koenig & Bauer, Canon, Fujifilm and Komori; pre-press with Enfocus Switch and Esko; web-to-print with XMPie, Infigo, Vpress, ROI360 and PrintJob; shipping via Shipmate; plus a RESTful API for bespoke connections to any third-party system.',
  },
  {
    q: 'How does an Imprint MIS implementation work?',
    a: 'Implementation starts with assisted configuration and training: we set up defaults such as VAT rates and customer mark-ups in close consultation with your team, rather than taking an "out of the box" approach. We also import your existing customers, prospects, suppliers and stock levels from external sources so you can transition as quickly as possible.',
  },
  {
    q: 'How is Imprint MIS licensed and priced?',
    a: 'We do not penalise customers on the number of licensed users. We examine your business, quote upfront for the system you actually need, and timetable the required training days. We can also offer financial support to help spread the upfront costs.',
  },
  {
    q: 'Can I see Imprint MIS before committing?',
    a: 'Yes — we offer a free, no-obligation demo tailored to your sector. Contact us on +44 (0)1245 231670 or via the contact form and one of our technical team (not a salesperson) will walk you through the system.',
  },
];

export const sectorFaqs = [
  {
    q: 'Does Imprint have a dedicated MIS for carton and packaging manufacturers?',
    a: 'Yes. Our cartons solution is a dedicated system, not an adapted commercial-print product. It handles CAD-driven estimating, die and stereo management, multi-part cartons, and integrates with pre-press tools like Esko for accurate one-up and layout data.',
  },
  {
    q: 'What does Imprint MIS offer commercial and litho printers?',
    a: 'Multi-section estimating, sheet and ganging optimisation, press scheduling and full job costing from prepress right through to despatch — proven with some of the largest commercial printers in the UK.',
  },
  {
    q: 'Can Imprint MIS handle security printing requirements?',
    a: 'Yes. Our security print solution supports the audit trails, numbering, spoils tracking and accountability that security and transactional printers require, and is used by established UK security printers such as A1 Security Print.',
  },
  {
    q: 'Does Imprint support direct mail and mailing houses?',
    a: 'Yes. The direct mail solution manages data-driven jobs, enclosing lines, postage and fulfilment alongside conventional print, used by mailing specialists such as Mail Solutions and Latcham.',
  },
  {
    q: 'What if my business spans several sectors?',
    a: 'Many of our customers do. Because every Imprint installation is configured around your business — and we own all of our own code — a single system can combine sector modules such as commercial print plus direct mail, or cartons plus labels, without bolt-on compromises.',
  },
  {
    q: 'My sector is not listed — can Imprint still help?',
    a: 'Almost certainly. The sectors shown are our most established, but the system is bespoke by design. Talk to our technical team about your workflow and we will tell you honestly whether Imprint MIS is a good fit.',
  },
];
